import React, { useContext, useEffect } from 'react';
import bountyRequestDone from '../../assets/bountyRequestDone.gif';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { BountiesContext } from '../../contexts/BountiesContext';
const RequestCreated = ({ isFundingRequested }) => {
    const { isEdit, bountyEditDetails, loadingEditDetails, organisation } = useContext(BountiesContext);
    const isCreationRequested = organisation?.country === "IN";
    const navigate = useNavigate();
    useEffect(function () {
        const timeoutId = setTimeout(() => {
            navigate(-1);
            // toast.success(
            //     isFundingRequested
            //         ? 'Bounty is now live on the ‘Impact Landscapes’ App!'
            //         : 'Bounty is now live on the ‘Impact Miner’ App!'
            // );
        }, '2800');
        return () => clearTimeout(timeoutId);
    }, []);
    return (
        <div className="flex items-center h-[90vh] justify-center relative">
            <div className="">
                {/* <p className="text-3xl font-semibold text-textPrimary">Bounty is being sent for treasury approval</p> */}
                <p className="text-3xl font-semibold text-textPrimary absolute left-[50%] translate-x-[-50%]  top-24">
                    {' '}
                    {isFundingRequested
                        ? 'Funding request has been submitted to Impact Landscapes!'
                        : isCreationRequested
                            ? 'We’ve submitted your activity creation request. You’ll be notified once it’s approved'
                            : 'Bounty is published and live on Impact Miner!'}
                </p>
                <div className="flex items-center justify-center">
                    <img src={bountyRequestDone} alt="" />
                </div>
            </div>
        </div>
    );
};

export default RequestCreated;
